import React from 'react';
import { Button, Icon } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import { connect } from 'react-redux';
import { showWorkspaceRequestReceipt } from '@/workspaces/actions';

const RequestWorkspaceReceiptButton = ({ request, showReceipt }) => {
  const intl = useIntl();
  return (
    <Button
      icon
      size="mini"
      className="aridhia-request-workspace-receipt-button float-r"
      data-tooltip={intl.formatMessage({ id: 'actions.view.request' })}
      data-position="left center"
      onClick={() => showReceipt(
        request.workspace_reference || request.workspace_name,
        request.workspace_request_form,
      )}
    >
      <Icon
        name="align justify"
        className="primary"
        alt={intl.formatMessage({ id: 'actions.view.request' })}
      />
    </Button>
  );
};

const mapDispatchToProps = {
  showReceipt: showWorkspaceRequestReceipt,
};

export default connect(null, mapDispatchToProps)(RequestWorkspaceReceiptButton);
